module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workshops-bespoke"
  }, [_c('nav-1'), _vm._v(" "), _c('hero', {
    attrs: {
      "image": _vm.hero
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "carousel-wrapper"
  }, [_c('h4', {
    staticClass: "size__content__default pos__content__center"
  }, [_vm._v("\n      We have worked with clients across the art, commercial and education sectors and partnered with curators, brands and experts from other fields.\n    ")]), _vm._v(" "), _c('flickity', {
    ref: "flickity",
    staticClass: "carousel",
    attrs: {
      "options": _vm.flickityOptions
    }
  }, _vm._l((_vm.carousel), function(cell, index) {
    return _c('div', {
      staticClass: "carousel-cell"
    }, [_c('div', {
      staticClass: "carousel-media",
      style: ({
        'backgroundImage': 'url(' + cell.image + ')',
        'backgroundPosition': index === 2 ? 'top center' : 'bottom center'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-text"
    }, [_c('h4', [_vm._v(_vm._s(cell.text))])])])
  }))], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-text"
  }, [_c('h1', [_vm._v("Workshop Strategy & Partnership")]), _vm._v(" "), _c('h4', {
    staticClass: "size__content__default pos__content__center",
    attrs: {
      "xxxxxcontenteditable": ""
    }
  }, [_vm._v("\n      Beyond learning, workshops can serve as a powerful tool for brands and institutions to foster meaningful relationships with their customers. "), _vm._v(" Discover how our workshops can facilitate your event, exhibition programme or product launch to connect with your audience on a more engaging level. Whether it’s creating a cookbook via a workshop app, branding a festival or co-creating artworks with 400 children, we offer a full workshop strategy for:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "strategy-list size__content__default pos__content__center"
  }, [_c('ul', {}, [_c('li', [_c('h4', [_vm._v("Exhibition programmes")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Education projects")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Experiential installations")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Brand activation")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Product launch experiences")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Events and festivals")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Community programmes")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quotes size__content__wide pos__content__center"
  }, [_c('div', {
    staticClass: "quote"
  }, [_c('h4', [_vm._v("“Hato led a risograph workshop for our partnership with The Conran Shop during LDF, we really enjoyed working with Hato on this project. They're super efficient, provided innovative concepts and a pleasure to work with!”")]), _vm._v(" "), _c('p', [_vm._v("Manda Wilks, Project Manager, It's Nice That")])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('h4', [_vm._v("“Hato’s energy and enthusiasm for playing with printing led to an imaginative and fun day for families at the RA. Families colourfully reimagined abstract works guided by the Hato team which allowed parents and children to create in an exploratory way discovering new printing skills”")]), _vm._v(" "), _c('p', [_vm._v("Gwen Ramsay, Family Programmer, Royal Academy of Arts.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-logos"
  }, [_c('img', {
    staticClass: "size__content__narrow",
    attrs: {
      "src": require("../assets/clients/strategy-logo-blocks-2.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clients-wrapper"
  }, [_c('h4', {
    staticClass: "size__content__narrow pos__content__center"
  }, [_vm._v("\n      We have worked with clients across the art, commercial and education sectors and partnered with curators, brands, educators and experts from other fields.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "clients layout-b xxxlayout-a"
  }, [_c('div', [_c('h3', [_vm._v("It’s Nice That")]), _vm._v(" "), _c('p', [_vm._v("Strategy"), _c('br'), _vm._v("Brand Partnership")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Pick Me Up")]), _vm._v(" "), _c('p', [_vm._v("Festival Activation"), _c('br'), _vm._v("Strategy ")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Facebook")]), _vm._v(" "), _c('p', [_vm._v("Strategy"), _c('br'), _vm._v("Analog and Digital Engagement ")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Royal Academy")]), _vm._v(" "), _c('p', [_vm._v("Strategy"), _c('br'), _vm._v("Co-creation"), _c('br'), _vm._v("Exhibition")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Urban Outfitters")]), _vm._v(" "), _c('p', [_vm._v("Brand Partnership"), _c('br'), _vm._v("Strategy ")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Liverpool Biennial")]), _vm._v(" "), _c('p', [_vm._v("Education"), _c('br'), _vm._v("Community"), _c('br'), _vm._v("Co-design"), _c('br'), _vm._v("Digital Engagement")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("The V&A")]), _vm._v(" "), _c('p', [_vm._v("Education")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("University of Arts London")]), _vm._v(" "), _c('p', [_vm._v("Strategy")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Edgware Road Project")]), _vm._v(" "), _c('p', [_vm._v("Strategy"), _c('br'), _vm._v("Co-creation"), _c('br'), _vm._v("Exhibition")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Tate Exchange")]), _vm._v(" "), _c('p', [_vm._v("Education"), _c('br'), _vm._v("Strategy"), _c('br'), _vm._v("Publishing")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("British Council")]), _vm._v(" "), _c('p', [_vm._v("Strategy"), _c('br'), _vm._v("Co-creation"), _c('br'), _vm._v("Exhibition")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-wrapper"
  }, [_c('div', {
    staticClass: "action"
  }, [_c('h3', [_vm._v("Get in touch to learn more about our bespoke workshops, or any general enquiries on workshops.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:bespoke@hatopress.net?subject=Strategy and Partnership"
    }
  }, [_vm._v("bespoke@hatopress.net")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+44-207-729-5585"
    }
  }, [_vm._v("+44 (0)207 729 5585")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e99f430","transformToRequire":{"img":"src","audio":"src","video":"poster"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkshopsStrategy.vue
// module id = 216
// module chunks = 1